import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from './useFetch';

const useFacebookPixelSettings = (pixelId) => {
  const fetch = useFetch();
  const { accountId, domainId } = useParams();
  const [pixelSettings, setPixelSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pixelId) {
      setPixelSettings(null);
      setError(null);
      setIsLoading(false);
      return undefined;
    }

    let isUnmounted = false;
    setIsLoading(true);
    setError(null);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebook/pixelSettings/${pixelId}`)
      .then((res) => {
        if (!isUnmounted) setPixelSettings(res);
      })
      .catch((e) => {
        if (!isUnmounted) setError(e);
      })
      .finally(() => {
        if (!isUnmounted) setIsLoading(false);
      });

    return () => {
      isUnmounted = true;
    };
  }, [fetch, accountId, domainId, pixelId]);

  return [pixelSettings, isLoading, error];
};

export default useFacebookPixelSettings;
